import texts from 'src/modules/market/bots/texts'
import { HIDE_CONFIRM_DIALOG } from 'src/vuex/modules/confirm-dialog/types'
import {
  NOTIFY_ERROR,
  NOTIFY_SUCCESS
} from '../../../../vuex/modules/snackbar/types'
import {
  startETP,
  startETR,
  stopETP,
  stopETR
} from '../apiCalls'

const state = {
  etr_bot_status: false,
  etp_bot_status: false,
  bots_view_loading: true
}

const mutations = {
  set_bots_view_loading(state, loading) {
    state.bots_view_loading = loading
  },
  set_etr_bot_status(state, status) {
    state.etr_bot_status = status
  },
  set_etp_bot_status(state, status) {
    state.etp_bot_status = status
  }
}

const actions = {
  // ETR
  toggle_ETR_bot({ commit, state }) {
    commit('set_etr_bot_status', !state.etr_bot_status)
  },
  activate_ETR_bot({ commit, dispatch }) {
    commit('set_bots_view_loading', true)
    commit(HIDE_CONFIRM_DIALOG, null, { root: true })

    startETR()
      .then(() => {
        commit('set_etr_bot_status', true)
        dispatch(NOTIFY_SUCCESS, {
          message: texts.ETR.notifications.start_success
        })
      })
      .catch(() => {
        dispatch('toggle_ETR_bot')
        dispatch(NOTIFY_ERROR, {
          message: texts.ETR.notifications.start_error
        })
      })
      .finally(() => {
        commit('set_bots_view_loading', false)
      })
  },
  pause_ETR_bot({ commit, dispatch }) {
    commit('set_bots_view_loading', true)
    commit(HIDE_CONFIRM_DIALOG, null, { root: true })

    stopETR()
      .then(() => {
        commit('set_etr_bot_status', false)
        dispatch(NOTIFY_SUCCESS, {
          message: texts.ETR.notifications.stop_success
        })
      })
      .catch(() => {
        dispatch('toggle_ETR_bot')
        dispatch(NOTIFY_ERROR, {
          message: texts.ETR.notifications.stop_error
        })
      })
      .finally(() => {
        commit('set_bots_view_loading', false)
      })
  },
  // ETP
  toggle_ETP_bot({ commit, state }) {
    commit('set_etp_bot_status', !state.etp_bot_status)
  },
  activate_ETP_bot({ commit, dispatch }) {
    commit('set_bots_view_loading', true)
    commit(HIDE_CONFIRM_DIALOG, null, { root: true })

    startETP()
      .then(() => {
        commit('set_etp_bot_status', true)
        dispatch(NOTIFY_SUCCESS, {
          message: texts.ETP.notifications.start_success
        })
      })
      .catch(() => {
        dispatch('toggle_etp_bot')
        dispatch(NOTIFY_ERROR, {
          message: texts.ETP.notifications.start_error
        })
      })
      .finally(() => {
        commit('set_bots_view_loading', false)
      })
  },
  pause_ETP_bot({ commit, dispatch }) {
    commit('set_bots_view_loading', true)
    commit(HIDE_CONFIRM_DIALOG, null, { root: true })

    stopETP()
      .then(() => {
        commit('set_etp_bot_status', false)
        dispatch(NOTIFY_SUCCESS, {
          message: texts.ETP.notifications.stop_success
        })
      })
      .catch((err) => {
        dispatch('toggle_etp_bot')
        dispatch(NOTIFY_ERROR, {
          message: texts.ETP.notifications.stop_error
        })
      })
      .finally(() => {
        commit('set_bots_view_loading', false)
      })
  }
}

export default {
  state,
  mutations,
  actions
}
